import WhatHelpers from './whatHelpers'
import WhenHelpers from './whenHelpers'
import ControlHelpers from './controlHelpers'
import { getTranslation } from './translations'

window.config = window.config || {}

/**
 * Get array of default(trivia) control items
 * return @array []
 */

function getDefaultControls() {
    return [
        {
            what: 'app.popups.enable',
            when: 'always',
            place: 'leftpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('feedbackAfterAnswers'),
            sortIndex: 0,
        },
        {
            what: 'app.coverScreen.enable',
            when: 'always',
            place: 'leftpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('coverScreen'),
            sortIndex: 0,
        },
        {
            what: 'app.userForm.enable',
            when: 'always',
            place: 'leftpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('userForm'),
            sortIndex: 0,
        },
        {
            what: 'app.screenProgress.showQuestionProgress',
            when: 'always',
            place: 'leftpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('showQuestionProgress'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.backgroundColor',
            when: 'screenShown',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('backgroundColor'),
            sortIndex: 40,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.backgroundImage',
            when: 'screenShown',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('backgroundImage'),
            sortIndex: 50,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].src',
            when: 'selected',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('chooseImage'),
            sortIndex: 50,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderRadius',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderRadius'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderWidth',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderWidth'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('borderColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].dropShadow',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('dropShadow'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].blur',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('blur'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].grayscale',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('grayscale'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=TextOption].backgroundColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('backgroundColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=TextOption].borderRadius',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderRadius'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=TextOption].borderWidth',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderWidth'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=TextOption].borderColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('borderColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=TextOption].dropShadow',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('dropShadow'),
            sortIndex: 0,
        },
        // {
        //     what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].tel',
        //     when: 'selected',
        //     place: 'rightpanel',
        //     view: 'textinput',
        //     name: 'StringControl',
        //     label: getTranslation('phoneNumber'),
        //     sortIndex: 1,
        // },
        // {
        //     what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].msg',
        //     when: 'selected',
        //     place: 'rightpanel',
        //     view: 'textinput',
        //     name: 'StringControl',
        //     label: getTranslation('preFilledMessage'),
        //     sortIndex: 1,
        // },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderRadius',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderRadius'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderWidth',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderWidth'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('borderColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].backgroundColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('backgroundColor'),
            sortIndex: 40,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].dropShadow',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('dropShadow'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].openUrl',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('openUrl'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].imageSrc',
            when: 'selected',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('icon'),
            sortIndex: 50,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=UserDataForm].needTitle',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('title'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=UserDataForm].firstNameField',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('firstName'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=UserDataForm].lastNameField',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('lastName'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=UserDataForm].emailField',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('email'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=UserDataForm].phoneField',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('phone'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=UserDataForm].authorPrivacyPolicy',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('linkPrivacyPolicy'),
            sortIndex: 0,
        },
        {
            // Добавление опции в контекстном меню
            what: WhatHelpers.componentsOnScreenWithTag('question'),
            when: WhenHelpers.onlyOneSelectedAndHasTag('option'),
            place: 'quickcontrolpanel',
            view: 'addquickbutton', // в config.js этот контрол описан как тип 'quickcontrolpanel' и будет показываться только там
            name: 'AddHashlistElementControl',
            prototype: (control, { componentIds, componentProps }) => {
                // if only one selected
                if (!componentIds || componentIds.length !== 1) {
                    return null
                }
                const props = componentProps[componentIds[0]]
                //TODO clone ?
                return {
                    ...props,
                    text: props.text,
                    left: props.left + 10,
                    top: props.top + 10,
                    data: { ...props.data, points: 0, popupId: '', copyPopupId: props.data.popupId }, // при добавлении новой опции она неверный ответ по умолчанию
                }
            },
        },
        {
            // Удаление любого компонента
            what: WhatHelpers.anyComponentOnScreen(),
            when: WhenHelpers.onlyOneSelected(),
            place: 'quickcontrolpanel',
            view: 'deletequickbutton',
            name: 'DeleteHashlistElementControl',
            sortIndex: -1,
        },
        {
            // Подсветка верного ответа (при клике - делает НЕверным)
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ tags=~option].data.points',
            when: WhenHelpers.onlyOneSelectedAndDataEqual({ points: 1 }),
            place: 'quickcontrolpanel',
            view: 'textlabel',
            name: 'TextLabel',
            props: {
                text: getTranslation('itsCorrectOption'),
                icon: '/static/media/active.svg',
                getValue: () => 0,
            },
            sortIndex: 50,
        },
        {
            // Сделать опцию верным ответом
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ tags=~option].data.points',
            when: WhenHelpers.onlyOneSelectedAndDataEqual({ points: 0 }), // показать только когда опция - неверный ответ
            place: 'quickcontrolpanel',
            view: 'textlabel',
            name: 'TextLabel',
            props: { text: getTranslation('setAsCorrect'), icon: '/static/media/normal.svg', getValue: () => 1 }, // 1 - сделать верным ответом
            sortIndex: 50,
        },
        // {
        //     // Сделать опцию НЕверным ответом
        //     what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ tags=~option].data.points',
        //     when: WhenHelpers.onlyOneSelectedAndDataEqual({ points: 1 }),
        //     place: 'quickcontrolpanel',
        //     view: 'textlabel',
        //     name: 'TextLabel',
        //     props: { text: getTranslation('setAsIncorrect'), icon: '', getValue: () => 0 },
        //     sortIndex: 50,
        // },
        {
            // Перестановка компонента на задний план
            what: WhatHelpers.anyComponentOnScreen(),
            when: WhenHelpers.onlyOneSelected(),
            place: 'quickcontrolpanel',
            view: 'textlabel',
            name: 'TextLabel',
            props: {
                text: getTranslation('sendToBack'),
                icon: '/static/media/move-down.svg',
                onClick: control => {
                    control.controlEventCallback(
                        window.ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED,
                        control,
                        {
                            newElementIndex: 0,
                        },
                    )
                },
            },
            sortIndex: 25,
        },
        {
            // Перестановка компонента на передний план
            what: WhatHelpers.anyComponentOnScreen(),
            when: WhenHelpers.onlyOneSelected(),
            place: 'quickcontrolpanel',
            view: 'textlabel',
            name: 'TextLabel',
            props: {
                text: getTranslation('bringToFront'),
                icon: '/static/media/move-up.svg',
                onClick: control => {
                    control.controlEventCallback(
                        window.ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED,
                        control,
                        {
                            newElementIndex: 9999,
                        },
                    )
                },
            },
            sortIndex: 30,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=TextOption].imageSrc',
            when: 'selected',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('optionBackground'),
            sortIndex: 50,
        },
        /**
         * Controls of Progress component
         */
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].color',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('fontColor'),
            sortIndex: 40,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].fontSize',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('fontSize'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].dotSize',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('dotSize'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].completionBackground',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('completionBackgroundColor'),
            sortIndex: 40,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].background',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('backgroundColor'),
            sortIndex: 40,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].variant',
            when: 'selected',
            place: 'rightpanel',
            view: 'dropdown',
            name: 'Alternative',
            label: 'Variant',
            possibleValues: [
                { option: getTranslation('text'), value: 'variant0' },
                { option: getTranslation('progressBar'), value: 'variant1' },
                { option: getTranslation('stepBar'), value: 'variant2' },
                { option: getTranslation('dotsBar'), value: 'variant3' },
            ],
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].borderRadius',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderRadius'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].borderWidth',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderWidth'),
            sortIndex: 0,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Progress].borderColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('borderColor'),
            sortIndex: 40,
        },
        {
            // Общее выравнивание группы элементов "Tidy up"
            // Если по top/left/w/h у группы компонентов небольшое отличие то эти значения усредняются и элементы выравниваются
            what: WhatHelpers.anyComponentOnScreen(),
            when: WhenHelpers.groupSelected(),
            place: 'quickcontrolpanel',
            view: 'textlabel',
            name: 'TextLabel',
            props: {
                text: getTranslation('tidyUp'),
                icon: '/static/media/tidy-up.svg',
                onClick: control => {
                    control.controlEventCallback(window.ControlManager.EVENT_PROCESS_SELECTED_COMPONENTS, control, {
                        process: ControlHelpers.tidyUp,
                    })
                },
            },
            sortIndex: 100,
        },
        //TODO четыре контрола инпута Safe zone в будущем надо объединить в один специальный контрол чтобы выглядело компактнее
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szTop',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('szTop'),
            sortIndex: 0,
            isExpert: true,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szLeft',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('szLeft'),
            sortIndex: 0,
            isExpert: true,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szRight',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('szRight'),
            sortIndex: 0,
            isExpert: true,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szBottom',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('szBottom'),
            sortIndex: 0,
            isExpert: true,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.components./^[0-9a-z]+$/.displayType',
            when: 'selected',
            place: 'rightpanel',
            view: 'dropdown',
            name: 'Alternative',
            label: getTranslation('displayType'),
            possibleValues: [
                { option: getTranslation('flow'), value: 'flow' },
                { option: getTranslation('decor'), value: 'decor' },
            ],
            sortIndex: 0,
            isExpert: true,
        },

        // components for popup
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.backgroundColor',
            when: 'popupShown',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('backgroundColor'),
            sortIndex: 40,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.backgroundImage',
            when: 'popupShown',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('backgroundImage'),
            sortIndex: 50,
        },
        {
            what: 'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.margin',
            when: 'popupShown',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('marginWeb'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderRadius',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderRadius'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderWidth',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderWidth'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('borderColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].backgroundColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('backgroundColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].dropShadow',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('dropShadow'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].openUrl',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('openUrl'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].imageSrc',
            when: 'selected',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('icon'),
            sortIndex: 50,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].src',
            when: 'selected',
            place: 'rightpanel',
            view: 'chooseimage',
            name: 'ChooseImage',
            label: getTranslation('chooseImage'),
            sortIndex: 50,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderRadius',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderRadius'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderWidth',
            when: 'selected',
            place: 'rightpanel',
            view: 'textinput',
            name: 'StringControl',
            label: getTranslation('borderWidth'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderColor',
            when: 'selected',
            place: 'rightpanel',
            view: 'colorpicker',
            name: 'StringControl',
            label: getTranslation('borderColor'),
            sortIndex: 40,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].dropShadow',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('dropShadow'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].blur',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('blur'),
            sortIndex: 0,
        },
        {
            what:
                'router.[screens HashList]./^[0-9a-z]+$/.popups./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].grayscale',
            when: 'selected',
            place: 'rightpanel',
            view: 'onoffswitcher',
            name: 'OnOff',
            label: getTranslation('grayscale'),
            sortIndex: 0,
        },
    ]
}

/**
 * Get option-object with components
 * return @object {}
 */
function getDefaultComponents() {
    return {
        text: {
            icon: '/static/media/icon-Aa.svg',
            iconHover: '/static/media/icon-Aa_hover.svg',
            items: [
                {
                    componentStyle: {
                        color: '#3C3C3C',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        fontSize: '24px',
                        lineHeight: '28px',
                        textAlign: 'center',
                    },
                    elementData: {
                        displayName: 'Text',
                        text: `<p class="ql-align-center"><strong class="ql-size-huge"><span class="ql-font-Roboto">${getTranslation(
                            'addHeading',
                        )} 1</span></strong></p>`,
                        width: 256,
                        height: 63,
                    },
                },
                {
                    componentStyle: {
                        color: '#3C3C3C',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                        fontSize: '20px',
                        lineHeight: '23px',
                        textAlign: 'center',
                    },
                    elementData: {
                        displayName: 'Text',
                        text: `<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto">${getTranslation(
                            'addHeading',
                        )} 2</span></p>`,
                        width: 256,
                        height: 63,
                    },
                },
                {
                    componentStyle: {
                        color: '#3C3C3C',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                        fontSize: '16px',
                        lineHeight: '19px',
                        textAlign: 'center',
                    },
                    elementData: {
                        displayName: 'Text',
                        text: `<p><span class="ql-align-center ql-font-Roboto">${getTranslation(
                            'addParagraph',
                        )}</span></p>`,
                        width: 256,
                        height: 63,
                    },
                },
                {
                    componentStyle: {
                        color: '#2990FB',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                        fontSize: '16px',
                        lineHeight: '19px',
                        textAlign: 'center',
                        textDecorationLine: 'underline',
                    },
                    elementData: {
                        displayName: 'Text',
                        text: `<p class="ql-align-center"><a href="https://interacty.me" rel="noopener noreferrer" target="_blank"><span class="ql-font-Roboto">${getTranslation(
                            'addLink',
                        )}</span></a></p>`,
                        width: 256,
                        height: 63,
                    },
                },
                {
                    componentStyle: {
                        color: '#3C3C3C',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                        fontSize: '12px',
                        lineHeight: '14px',
                        textAlign: 'center',
                    },
                    elementData: {
                        displayName: 'Text',
                        text: `<p class="ql-align-center"><span class="ql-size-small ql-font-Roboto">${getTranslation(
                            'addCaption',
                        )}</span></p>`,
                        width: 256,
                        height: 63,
                    },
                },
            ],
        },
        image: {
            icon: '/static/media/icon-image.svg',
            iconHover: '/static/media/icon-image_hover.svg',
            items: [
                {
                    tab: getTranslation('justImage'),
                    items: [
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-component-bg.jpg")',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                width: 72,
                                height: 72,
                                borderRadius: 0,
                                borderWidth: 0,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '156px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-lg_blur.png")',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                width: 800,
                                height: 300,
                                blur: true,
                                borderRadius: 0,
                                borderWidth: 0,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-component-bg.jpg")',
                                border: '4px solid #FFFFFF',
                                boxSizing: 'border-box',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                width: 72,
                                height: 72,
                                borderWidth: 4,
                                borderRadius: 0,
                                borderColor: '#fff',
                                dropShadow: true,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-component-bg.jpg")',
                                filter: 'grayscale(1)',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                grayscale: true,
                                borderRadius: 0,
                                borderWidth: 0,
                                width: 72,
                                height: 72,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '8px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-component-bg.jpg")',
                                borderRadius: '8px',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                width: 72,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 8,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '200px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-component-bg.jpg")',
                                borderRadius: '200px',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                borderRadius: 200,
                                borderWidth: 0,
                                width: 72,
                                height: 72,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '200px',
                            },
                            componentStyle: {
                                width: '72px',
                                height: '72px',
                                backgroundImage: 'url("/static/media/image-component-bg.jpg")',
                                border: '4px solid #FFFFFF',
                                boxSizing: 'border-box',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                                borderRadius: '200px',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                borderRadius: 200,
                                borderWidth: 4,
                                borderColor: '#fff',
                                dropShadow: true,
                                width: 72,
                                height: 72,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image_gif.png")',
                            },
                            elementData: {
                                displayName: 'ProgressiveImage',
                                width: 72,
                                height: 72,
                                borderRadius: 0,
                                borderWidth: 0,
                                src: `${window.location.origin}/static/media/image-answer.png`,
                            },
                        },
                    ],
                },
                {
                    tab: getTranslation('interactiveImage'),
                    hint: getTranslation('selectOptionHint1'),
                    items: [
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                // gridColumn: '1 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_blur.png")',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                width: 114,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 0,
                                text: '',
                                blur: true,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                border: '4px solid #FFFFFF',
                                boxSizing: 'border-box',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderWidth: 4,
                                borderColor: '#fff',
                                borderRadius: 0,
                                dropShadow: true,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                filter: 'grayscale(1)',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                grayscale: true,
                                width: 114,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                borderRadius: '8px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                borderRadius: '8px',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderRadius: 8,
                                borderWidth: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_gif.png")',
                                borderRadius: '8px',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderRadius: 0,
                                borderWidth: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },

                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '200px',
                            },
                            componentStyle: {
                                width: '72px',
                                height: '72px',
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                backgroundPosition: '50% 50%',
                                border: '4px solid #FFFFFF',
                                boxSizing: 'border-box',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                                borderRadius: '200px',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                borderRadius: 200,
                                borderWidth: 4,
                                borderColor: '#fff',
                                dropShadow: true,
                                width: 72,
                                height: 72,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '200px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                borderRadius: '200px',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                borderRadius: 200,
                                width: 72,
                                height: 72,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                    ],
                },
            ],
        },
        buttons: {
            icon: '/static/media/icon-buttons.svg',
            iconHover: '/static/media/icon-buttons_hover.svg',
            items: [
                {
                    tab: getTranslation('navigation'),
                    style: {},
                    items: [
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/start_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Lato" style="color: #FFFFFF">Start</span></p>',
                                styleVariant: 'primary',
                                width: 175,
                                height: 50,
                                backgroundColor: '#1877F2',
                                borderRadius: 40,
                                borderWidth: 0,
                                tags: '__plugin__coverStartBtn option',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/start_outline.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Start</span></p>',
                                styleVariant: 'secondaryLight',
                                width: 175,
                                height: 50,
                                borderRadius: 4,
                                borderColor: '#D8D8D8',
                                borderWidth: 1,
                                backgroundColor: 'white',
                                tags: '__plugin__coverStartBtn option',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/next_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Next</span></p>',
                                styleVariant: 'primary',
                                width: 82,
                                height: 44,
                                backgroundColor: '#2990FB',
                                borderRadius: 34,
                                borderWidth: 0,
                                tags: 'nextTag next',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/next_white.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Next</span></p>',
                                styleVariant: 'secondaryLight',
                                width: 82,
                                height: 44,
                                borderRadius: 4,
                                borderColor: '#D8D8D8',
                                borderWidth: 1,
                                backgroundColor: 'white',
                                tags: 'nextTag next',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/next-with-arrow_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Next</span></p>',
                                styleVariant: 'primary',
                                width: 102,
                                height: 44,
                                backgroundColor: '#2990FB',
                                borderRadius: 34,
                                borderWidth: 0,
                                iconName: 'arrowRight',
                                iconColor: '#FFFFFF',
                                iconPosition: 'right',
                                iconGap: 8,
                                tags: 'nextTag next',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/next-with-arrow_white.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Next</span></p>',
                                styleVariant: 'secondaryLight',
                                width: 102,
                                height: 44,
                                borderRadius: 4,
                                borderColor: '#D8D8D8',
                                borderWidth: 1,
                                backgroundColor: '#FFFFFF',
                                iconName: 'arrowRight',
                                iconColor: '#979797',
                                iconColorHover: '#787878',
                                iconPosition: 'right',
                                iconGap: 8,
                                tags: 'nextTag next',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/back-next_1.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: [
                                {
                                    displayName: 'Button',
                                    styleVariant: 'secondaryLight',
                                    text: '',
                                    backgroundColor: '',
                                    width: 44,
                                    height: 44,
                                    left: 20,
                                    // left: 0,
                                    // top: 278,
                                    borderRadius: 27,
                                    iconName: 'arrowLeft',
                                    iconColor: '#979797',
                                    iconColorHover: '#787878',
                                    iconGap: 0,
                                    iconPosition: 'left',
                                    tags: 'prevTag prev',
                                },
                                {
                                    displayName: 'Button',
                                    text:
                                        '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Next</span></p>',
                                    styleVariant: 'primary',
                                    width: 102,
                                    height: 44,
                                    backgroundColor: '#2990FB',
                                    left: 678,
                                    // left: 698,
                                    // top: 278,
                                    borderRadius: 34,
                                    borderWidth: 0,
                                    iconName: 'arrowRight',
                                    iconColor: '#FFFFFF',
                                    iconPosition: 'right',
                                    iconGap: 8,
                                    tags: 'nextTag next',
                                },
                            ],
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/back-next_2.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: [
                                {
                                    displayName: 'Button',
                                    styleVariant: 'secondaryLight',
                                    text: '',
                                    backgroundColor: '',
                                    width: 44,
                                    height: 44,
                                    left: 20,
                                    // left: 0,
                                    // top: 278,
                                    borderRadius: 27,
                                    iconName: 'arrowLeft',
                                    iconColor: '#979797',
                                    iconColorHover: '#787878',
                                    iconGap: 0,
                                    iconPosition: 'left',
                                    tags: 'prevTag prev',
                                },
                                {
                                    displayName: 'Button',
                                    styleVariant: 'secondaryLight',
                                    text: '',
                                    backgroundColor: '',
                                    width: 44,
                                    height: 44,
                                    left: 736,
                                    // left: 756,
                                    // top: 278,
                                    borderRadius: 27,
                                    iconName: 'arrowRight',
                                    iconColor: '#979797',
                                    iconColorHover: '#787878',
                                    iconGap: 0,
                                    iconPosition: 'left',
                                    tags: 'nextTag next',
                                },
                            ],
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/back-next_3.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: [
                                {
                                    displayName: 'Button',
                                    styleVariant: 'icon',
                                    text: '',
                                    backgroundColor: 'rgba(255, 255, 255, 0)',
                                    width: 44,
                                    height: 44,
                                    left: 20,
                                    // left: 0,
                                    // top: 278,
                                    borderRadius: 0,
                                    borderWidth: 0,
                                    iconName: 'triangleLeft',
                                    iconColor: '#D8D8D8',
                                    iconColorHover: '#787878',
                                    iconGap: 0,
                                    iconPosition: 'left',
                                    tags: 'prevTag prev',
                                },
                                {
                                    displayName: 'Button',
                                    styleVariant: 'icon',
                                    text: '',
                                    backgroundColor: 'rgba(255, 255, 255, 0)',
                                    width: 44,
                                    height: 44,
                                    left: 736,
                                    // left: 756,
                                    // top: 278,
                                    borderRadius: 0,
                                    borderWidth: 0,
                                    iconName: 'triangleRight',
                                    iconColor: '#D8D8D8',
                                    iconColorHover: '#787878',
                                    iconGap: 0,
                                    iconPosition: 'left',
                                    tags: 'nextTag next',
                                },
                            ],
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/back-next_4.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: [
                                {
                                    displayName: 'Button',
                                    text:
                                        '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Back</span></p>',
                                    styleVariant: 'primary',
                                    width: 102,
                                    height: 44,
                                    left: 20,
                                    // left: 0,
                                    // top: 278,
                                    backgroundColor: '#2990FB',
                                    borderRadius: 34,
                                    borderWidth: 0,
                                    iconName: 'arrowLeft',
                                    iconColor: '#FFFFFF',
                                    iconPosition: 'left',
                                    iconGap: 8,
                                    tags: 'prevTag prev',
                                },
                                {
                                    displayName: 'Button',
                                    text:
                                        '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Next</span></p>',
                                    styleVariant: 'primary',
                                    width: 102,
                                    height: 44,
                                    left: 678,
                                    // left: 698,
                                    // top: 278,
                                    backgroundColor: '#2990FB',
                                    borderRadius: 34,
                                    borderWidth: 0,
                                    iconName: 'arrowRight',
                                    iconColor: '#FFFFFF',
                                    iconPosition: 'right',
                                    iconGap: 8,
                                    tags: 'nextTag next',
                                },
                            ],
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/back-next_5.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: [
                                {
                                    displayName: 'Button',
                                    text:
                                        '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Back</span></p>',
                                    styleVariant: 'secondaryLight',
                                    width: 102,
                                    height: 44,
                                    left: 20,
                                    // left: 0,
                                    // top: 278,
                                    borderRadius: 4,
                                    borderColor: '#D8D8D8',
                                    borderWidth: 1,
                                    backgroundColor: '#FFFFFF',
                                    iconName: 'arrowLeft',
                                    iconColor: '#979797',
                                    iconColorHover: '#787878',
                                    iconPosition: 'left',
                                    iconGap: 8,
                                    tags: 'prevTag prev',
                                },
                                {
                                    displayName: 'Button',
                                    text:
                                        '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Next</span></p>',
                                    styleVariant: 'secondaryLight',
                                    width: 102,
                                    height: 44,
                                    left: 678,
                                    // left: 698,
                                    // top: 278,
                                    borderRadius: 4,
                                    borderColor: '#D8D8D8',
                                    borderWidth: 1,
                                    backgroundColor: '#FFFFFF',
                                    iconName: 'arrowRight',
                                    iconColor: '#979797',
                                    iconColorHover: '#787878',
                                    iconPosition: 'right',
                                    iconGap: 8,
                                    tags: 'nextTag next',
                                },
                            ],
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/restart_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Restart</span></p>',
                                styleVariant: 'primary',
                                width: 122,
                                height: 44,
                                backgroundColor: '#2990FB',
                                borderRadius: 34,
                                borderWidth: 0,
                                iconName: 'restart',
                                iconColor: '#FFFFFF',
                                iconPosition: 'left',
                                iconGap: 8,
                                tags: 'restart',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/restart_white.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Restart</span></p>',
                                styleVariant: 'secondaryLight',
                                width: 122,
                                height: 44,
                                borderRadius: 4,
                                borderColor: '#D8D8D8',
                                borderWidth: 1,
                                backgroundColor: 'white',
                                iconName: 'restart',
                                iconColor: '#979797',
                                iconColorHover: '#787878',
                                iconPosition: 'left',
                                iconGap: 8,
                                tags: 'restart',
                            },
                        },
                    ],
                },
                {
                    tab: getTranslation('ctaButtons'),
                    style: {},
                    items: [
                        {
                            boxStyle: {
                                width: 256,
                                height: 63,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/open-site_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-normal ql-font-Roboto" style="color: #FFFFFF">Open site</span></p>',
                                width: 136,
                                height: 44,
                                backgroundColor: '#2990FB',
                                borderRadius: 40,
                                borderWidth: 0,
                                iconName: 'link',
                                iconColor: '#FFFFFF',
                                iconPosition: 'left',
                                iconGap: 12,
                                tags: 'externalLink',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 63,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/open-site_white.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-normal ql-font-Roboto" style="color: #787878">Open site</span></p>',
                                width: 136,
                                height: 44,
                                borderRadius: 4,
                                borderColor: '#D8D8D8',
                                borderWidth: 1,
                                backgroundColor: 'white',
                                iconName: 'link',
                                iconColor: '#787878',
                                iconPosition: 'left',
                                iconGap: 12,
                                tags: 'externalLink',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 63,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/download_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-normal ql-font-Roboto" style="color: #FFFFFF">Download</span></p>',
                                width: 136,
                                height: 44,
                                backgroundColor: '#2990FB',
                                borderRadius: 40,
                                borderWidth: 0,
                                iconName: 'download',
                                iconColor: '#FFFFFF',
                                iconPosition: 'left',
                                iconGap: 13,
                                tags: 'download',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 63,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/download_white.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-normal ql-font-Roboto" style="color: #787878">Download</span></p>',
                                width: 136,
                                height: 44,
                                borderRadius: 4,
                                borderColor: '#D8D8D8',
                                borderWidth: 1,
                                backgroundColor: 'white',
                                iconName: 'download',
                                iconColor: '#787878',
                                iconPosition: 'left',
                                iconGap: 13,
                                tags: 'download',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/whatsapp-chat_1.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Chat</span></p>',
                                width: 102,
                                height: 44,
                                borderRadius: 40,
                                borderWidth: 0,
                                backgroundColor: '#69E182',
                                iconName: 'whatsapp',
                                iconColor: '#FFFFFF',
                                iconPosition: 'left',
                                iconGap: 9,
                                tags: 'whatsapp-chat',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/whatsapp-chat_2.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Chat</span></p>',
                                width: 102,
                                height: 44,
                                borderRadius: 4,
                                borderWidth: 1,
                                borderColor: '#D8D8D8',
                                backgroundColor: '#FFFFFF',
                                iconName: 'whatsapp',
                                iconColor: '#787878',
                                iconPosition: 'left',
                                iconGap: 9,
                                tags: 'whatsapp-chat',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/fb-chat_1.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Chat</span></p>',
                                width: 102,
                                height: 44,
                                borderRadius: 40,
                                borderWidth: 0,
                                backgroundColor: '#2990FB',
                                iconName: 'messanger',
                                iconColor: '#FFFFFF',
                                iconPosition: 'left',
                                iconGap: 9,
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/fb-chat_2.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Chat</span></p>',
                                width: 102,
                                height: 44,
                                borderRadius: 4,
                                borderWidth: 1,
                                borderColor: '#D8D8D8',
                                backgroundColor: '#FFFFFF',
                                iconName: 'messanger',
                                iconColor: '#787878',
                                iconPosition: 'left',
                                iconGap: 9,
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/shop_1.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Shop</span></p>',
                                width: 105,
                                height: 44,
                                borderRadius: 40,
                                borderWidth: 0,
                                backgroundColor: '#2990FB',
                                iconName: 'shop',
                                iconColor: '#FFFFFF',
                                iconPosition: 'left',
                                iconGap: 11,
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/shop_2.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Shop</span></p>',
                                width: 105,
                                height: 44,
                                borderRadius: 4,
                                borderWidth: 1,
                                borderColor: '#D8D8D8',
                                backgroundColor: '#FFFFFF',
                                iconName: 'shop',
                                iconColor: '#787878',
                                iconPosition: 'left',
                                iconGap: 11,
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/launch_1.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Launch</span></p>',
                                width: 85,
                                height: 44,
                                borderRadius: 34,
                                borderWidth: 0,
                                backgroundColor: '#2990FB',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/launch_2.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #787878">Launch</span></p>',
                                width: 85,
                                height: 44,
                                borderRadius: 4,
                                borderWidth: 1,
                                borderColor: '#D8D8D8',
                                backgroundColor: '#FFFFFF',
                            },
                        },
                    ],
                },
                {
                    tab: getTranslation('share'),
                    style: {},
                    items: [
                        {
                            boxStyle: {
                                width: 124,
                                height: 58,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/fb-mini_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text: '',
                                width: 44,
                                height: 44,
                                iconName: 'facebook',
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                iconColor: '#1877F2',
                                iconGap: 0,
                                tags: 'remixcomponent facebook share socialShare shared_by_facebook',
                            },
                        },
                        {
                            boxStyle: {
                                width: 58,
                                height: 58,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/fb-mini_black.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text: '',
                                width: 44,
                                height: 44,
                                iconName: 'facebook',
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                iconColor: '#3C3C3C',
                                iconGap: 0,
                                tags: 'remixcomponent facebook share socialShare shared_by_facebook',
                            },
                        },
                        {
                            boxStyle: {
                                width: 58,
                                height: 58,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/fb-mini_gray.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text: '',
                                width: 44,
                                height: 44,
                                iconName: 'facebook',
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                iconColor: '#ffffff',
                                iconGap: 0,
                                tags: 'remixcomponent facebook share socialShare shared_by_facebook',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/fb_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Share</span></p>',
                                width: 109,
                                height: 44,
                                iconName: 'facebook',
                                backgroundColor: '#1877F2',
                                borderRadius: 40,
                                iconColor: '#ffffff',
                                iconPosition: 'left',
                                iconGap: 9,
                                tags: 'remixcomponent facebook share socialShare shared_by_facebook',
                            },
                        },
                        {
                            boxStyle: {
                                width: 124,
                                height: 58,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/vk-mini_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text: '',
                                width: 44,
                                height: 44,
                                iconName: 'vkontakte',
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                iconColor: '#4680C2',
                                iconGap: 0,
                                tags: 'remixcomponent vkontakte share socialShare shared_by_vkontakte',
                            },
                        },
                        {
                            boxStyle: {
                                width: 58,
                                height: 58,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/vk-mini_black.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text: '',
                                width: 44,
                                height: 44,
                                iconName: 'vkontakte',
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                iconColor: '#3C3C3C',
                                iconGap: 0,
                                tags: 'remixcomponent vkontakte share socialShare shared_by_vkontakte',
                            },
                        },
                        {
                            boxStyle: {
                                width: 58,
                                height: 58,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/vk-mini_white.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text: '',
                                width: 44,
                                height: 44,
                                iconName: 'vkontakte',
                                backgroundColor: 'rgba(255, 255, 255, 0)',
                                iconColor: '#ffffff',
                                iconGap: 0,
                                tags: 'remixcomponent vkontakte share socialShare shared_by_vkontakte',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 64,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/vk_blue.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'Button',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #FFFFFF">Share</span></p>',
                                width: 109,
                                height: 44,
                                iconName: 'vkontakte',
                                backgroundColor: '#4680C2',
                                borderRadius: 40,
                                iconColor: '#ffffff',
                                iconPosition: 'left',
                                iconGap: 9,
                                tags: 'remixcomponent vkontakte share socialShare shared_by_vkontakte',
                            },
                        },
                    ],
                },
            ],
        },
        answers: {
            icon: '/static/media/icon-answers.svg',
            iconHover: '/static/media/icon-answers_hover.svg',
            items: [
                {
                    tab: getTranslation('textAnswers'),
                    style: {},
                    items: [
                        {
                            boxStyle: {
                                width: 256,
                                height: 63,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/text-answer_1.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #3C3C3C">Possible answer</span></p>',
                                width: 256,
                                height: 54,
                                correctIndicator: 'none',
                                align: 'center',
                                backgroundColor: '#FFFFFF',
                                borderRadius: 4,
                                borderWidth: 0,
                                // align: 'center',
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: 256,
                                height: 63,
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/text-answer_2.svg")',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                text:
                                    '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #3C3C3C">Possible answer</span></p>',
                                width: 256,
                                height: 54,
                                correctIndicator: 'none',
                                align: 'left',
                                backgroundColor: '#FFFFFF',
                                borderRadius: 4,
                                borderWidth: 0,
                                // align: 'center',
                                tags: 'question option',
                            },
                        },
                        // {
                        //     boxStyle: {
                        //         width: 256,
                        //         height: 63,
                        //     },
                        //     componentStyle: {
                        //         backgroundImage: 'url("/static/media/text-answer_3.svg")',
                        //         backgroundRepeat: 'no-repeat',
                        //         backgroundPosition: '50% 50%',
                        //     },
                        //     elementData: {
                        //         displayName: 'TextOption',
                        //         text:
                        //             '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #3C3C3C">Possible answer</span></p>',
                        //         width: 256,
                        //         height: 54,
                        //         correctIndicator: 'unchecked',
                        //         align: 'left',
                        //         backgroundColor: '#FFFFFF',
                        //         borderRadius: 4,
                        //         borderWidth: 0,
                        //         // align: 'center',
                        //         tags: 'question option',
                        //     },
                        // },
                        // {
                        //     boxStyle: {
                        //         width: 256,
                        //         height: 63,
                        //     },
                        //     componentStyle: {
                        //         backgroundImage: 'url("/static/media/text-answer_4.svg")',
                        //         backgroundRepeat: 'no-repeat',
                        //         backgroundPosition: '50% 50%',
                        //     },
                        //     elementData: {
                        //         displayName: 'TextOption',
                        //         text:
                        //             '<p class="ql-align-center"><span class="ql-size-large ql-font-Roboto" style="color: #3C3C3C">Possible answer</span></p>',
                        //         width: 256,
                        //         height: 54,
                        //         correctIndicator: 'unchecked',
                        //         align: 'left',
                        //         backgroundColor: '#FFFFFF',
                        //         borderRadius: 4,
                        //         borderWidth: 0,
                        //         // align: 'center',
                        //         tags: 'question option',
                        //     },
                        // },
                    ],
                },
                {
                    tab: getTranslation('pictureAnswers'),
                    items: [
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                // gridColumn: '1 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_blur.png")',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                width: 114,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 0,
                                text: '',
                                blur: true,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                border: '4px solid #FFFFFF',
                                boxSizing: 'border-box',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderWidth: 4,
                                borderColor: '#fff',
                                borderRadius: 0,
                                dropShadow: true,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                filter: 'grayscale(1)',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                grayscale: true,
                                width: 114,
                                height: 72,
                                borderWidth: 0,
                                borderRadius: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                borderRadius: '8px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                borderRadius: '8px',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderRadius: 8,
                                borderWidth: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '114px',
                                height: '72px',
                                gridColumn: '2 / 4',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_gif.png")',
                                borderRadius: '8px',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                width: 114,
                                height: 72,
                                borderRadius: 0,
                                borderWidth: 0,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },

                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '200px',
                            },
                            componentStyle: {
                                width: '72px',
                                height: '72px',
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                backgroundPosition: '50% 50%',
                                border: '4px solid #FFFFFF',
                                boxSizing: 'border-box',
                                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                                borderRadius: '200px',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                borderRadius: 200,
                                borderWidth: 4,
                                borderColor: '#fff',
                                dropShadow: true,
                                width: 72,
                                height: 72,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                        {
                            boxStyle: {
                                width: '72px',
                                height: '72px',
                                borderRadius: '200px',
                            },
                            componentStyle: {
                                backgroundImage: 'url("/static/media/image-answer_cursor.png")',
                                borderRadius: '200px',
                                backgroundPosition: '50% 50%',
                            },
                            elementData: {
                                displayName: 'TextOption',
                                borderRadius: 200,
                                width: 72,
                                height: 72,
                                text: '',
                                imageSrc: `${window.location.origin}/static/media/image-answer.png`,
                                tags: 'question option',
                            },
                        },
                    ],
                },
            ],
        },
        logo: {
            icon: '/static/media/icon-logo.svg',
            iconHover: '/static/media/icon-logo_hover.svg',
            style: {},
            items: [
                {
                    boxStyle: {
                        width: 168,
                        height: 80,
                    },
                    componentStyle: {
                        backgroundImage: 'url("/static/media/logo-item_1.svg")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundColor: '#ffffff',
                    },
                    elementData: {
                        displayName: 'Button',
                        text: '',
                        width: 124,
                        height: 40,
                        backgroundColor: 'transparent',
                        imageSrc: `${window.location.origin}/static/media/logo-item_1.svg`,
                        tags: 'logo',
                    },
                },
                {
                    boxStyle: {
                        width: 80,
                        height: 80,
                    },
                    componentStyle: {
                        backgroundImage: 'url("/static/media/logo-item_2.svg")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundColor: '#ffffff',
                    },
                    elementData: {
                        displayName: 'Button',
                        text: '',
                        width: 54,
                        height: 60,
                        backgroundColor: 'transparent',
                        imageSrc: `${window.location.origin}/static/media/logo-item_2.svg`,
                        tags: 'logo',
                    },
                },
                {
                    boxStyle: {
                        width: 168,
                        height: 80,
                    },
                    componentStyle: {
                        backgroundImage: 'url("/static/media/logo-item_3.svg")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundColor: '#D8D8D8',
                    },
                    elementData: {
                        displayName: 'Button',
                        text: '',
                        width: 124,
                        height: 40,
                        backgroundColor: 'transparent',
                        imageSrc: `${window.location.origin}/static/media/logo-item_3.svg`,
                        tags: 'logo',
                    },
                },
                {
                    boxStyle: {
                        width: 80,
                        height: 80,
                    },
                    componentStyle: {
                        backgroundImage: 'url("/static/media/logo-item_4.svg")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                        backgroundColor: '#D8D8D8',
                    },
                    elementData: {
                        displayName: 'Button',
                        text: '',
                        width: 54,
                        height: 60,
                        backgroundColor: 'transparent',
                        imageSrc: `${window.location.origin}/static/media/logo-item_4.svg`,
                        openUrl: '',
                        tags: 'logo',
                    },
                },
            ],
        },
    }
}

/**
 * Конфигурация для каждого типа проект (ключ - поле 'customId' > toUpperCase в projectTypeDto)
 */
const projectType = {
    /**
     * Trivia Configuration
     */
    TRIVIA: {
        operations: {
            // описывают какие действия можно делать в редакторе
            //TODO
            // drag and drop components into the screen - descibe these kind of operations
            // add new screens - screen prototypes.
            // what kind of options user may add on the screen? only textoption, only imageoption, other?
            // copy-paste operations ?
            // adding new options by prototype
        },
        controls: getDefaultControls(),
        screens: {
            showScreenControl: true,
            groups: [
                {
                    show: true,
                    group: 'question_group',
                    name: getTranslation('questions'),
                    tag: 'question',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 2,
                    prototypes: [
                        {
                            name: getTranslation('textQuestion'),
                            icon: {
                                main: '/static/media/text_question.svg',
                                hover: '/static/media/text_question_hover.svg',
                            },
                            json: `{"backgroundColor":"#F7F7F7","backgroundImage":"","components":{"_orderedIds":["emeh5f","fkrwjx","5pe80r","yrr89s","5pvg79"],"emeh5f":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-huge' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourQuestion',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":404,"widthStrategy":"fixed","height":55,"left":198,"leftStrategy":"dynamic","top":156,"displayType":"flow","data":{"nextScreenId":""}},"fkrwjx":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 1</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"none","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":300,"displayType":"flow","data":{"nextScreenId":"","points":0}},"5pe80r":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 2</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":300,"displayType":"flow","data":{"nextScreenId":"","points":0}},"yrr89s":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 3</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":403,"displayType":"flow","data":{"nextScreenId":"","points":0}},"5pvg79":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 4</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"yrr89s","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":403,"displayType":"flow","data":{"nextScreenId":"","points":0}}},"tags":"screen question question1","disabled":false,"data":{"nextScreenId":"1ekp37"},"staticMarkup":"","hashlistId":"z6z9sh"}`,
                        },
                        {
                            name: getTranslation('photoSlide'),
                            icon: {
                                main: '/static/media/photo_question.svg',
                                hover: '/static/media/photo_question_hover.svg',
                            },
                            json: `{"backgroundColor":"#F7F7F7","backgroundImage":"","components":{"_orderedIds":["6gn666","pho6dj","otvi7n","m009g4","z7hxdh","rw77bd"],"6gn666":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-huge' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourQuestion',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":404,"widthStrategy":"fixed","height":55,"left":198,"leftStrategy":"dynamic","top":50,"displayType":"flow","data":{"nextScreenId":""}},"pho6dj":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 1</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"none","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":363,"displayType":"flow","data":{"nextScreenId":"","points":0}},"otvi7n":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 2</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":363,"displayType":"flow","data":{"nextScreenId":"","points":0}},"m009g4":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 3</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":467,"displayType":"flow","data":{"nextScreenId":"","points":0}},"z7hxdh":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 4</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"yrr89s","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":467,"displayType":"flow","data":{"nextScreenId":"","points":0}},"rw77bd":{"width":400,"height":207,"backgroundSize":"cover","blur":false,"grayscale":false,"dropShadow":false,"borderWidth":0,"borderRadius":4,"borderColor":"#000000","animation":"none","src":"https://p.testix.me/images/products/common/i/Placeholder.png","srcThumb":"","id":"none","tags":"remixcomponent","displayName":"ProgressiveImage","widthStrategy":"fixed","left":200,"leftStrategy":"dynamic","top":126,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen question question1","disabled":false,"data":{"nextScreenId":"908325"},"staticMarkup":"","hashlistId":"1ekp37"}`,
                        },
                        {
                            name: getTranslation('photoOptions'),
                            icon: {
                                main: '/static/media/photo_answer.svg',
                                hover: '/static/media/photo_answer_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"","components":{"_orderedIds":["rnlv4a","9dqhi2","z4dqtm","hxfwp3"],"rnlv4a":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourQuestion',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":404,"widthStrategy":"fixed","height":55,"left":198,"leftStrategy":"dynamic","top":88,"displayType":"flow","data":{"nextScreenId":""}},"9dqhi2":{"text":"<p class='ql-align-center'><br></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":0,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/1207675/2684","id":"none","tags":"question option","displayName":"TextOption","width":197,"widthStrategy":"fixed","height":200,"left":74,"leftStrategy":"dynamic","top":212,"displayType":"flow","data":{"nextScreenId":"","points":0}},"z4dqtm":{"text":"<p><br></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":0,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/1207675/2684","id":"9dqhi2","tags":"question option","displayName":"TextOption","width":197,"widthStrategy":"fixed","height":200,"left":301.5,"leftStrategy":"dynamic","top":212,"displayType":"flow","data":{"nextScreenId":"","points":0}},"hxfwp3":{"text":"<p><br></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":3,"borderColor":"#D8D8D8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/1207675/2684","id":"z4dqtm","tags":"question option","displayName":"TextOption","width":197,"widthStrategy":"fixed","height":200,"left":530,"leftStrategy":"dynamic","top":212,"displayType":"flow","data":{"nextScreenId":"","points":0}}},"tags":"screen question question1","disabled":false,"data":{"nextScreenId":"idByFunction:calcTriviaRes"},"staticMarkup":"","hashlistId":"908325"}`,
                        },
                    ],
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'result_group',
                    name: getTranslation('results'),
                    tag: 'result',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 5,
                    minLength: 1,
                    prototypes: [
                        {
                            name: getTranslation('plainText'),
                            icon: {
                                main: '/static/media/plain_text.svg',
                                hover: '/static/media/plain_text_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"","components":{"_orderedIds":["a5zqu2","87djai","5btnep","qufiwa"],"a5zqu2":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":454,"widthStrategy":"fixed","height":70,"left":173,"leftStrategy":"dynamic","top":162,"displayType":"flow","data":{"nextScreenId":""}},"87djai":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'tryAgain',
                            )}</strong></p>","sizeMod":"normal","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","id":"none","tags":"restart","displayName":"Button","width":195,"widthStrategy":"fixed","height":52,"left":302.5,"leftStrategy":"dynamic","top":391,"displayType":"flow","data":{"nextScreenId":""}},"5btnep":{"text":"U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;span class=U+34;ql-size-large ql-font-RobotoU+34; style=U+34;color: #FFFFFFU+34;U+62;ShareU+60;/spanU+62;U+60;/pU+62;","styleVariant":"none","sizeMod":"normal","borderRadius":40,"borderWidth":0,"borderColor":"","dropShadow":false,"backgroundColor":"#1877F2","isArrow":false,"arrowType":"default","arrowDirection":"right","arrowPosition":"center","arrowColor":"#fff","iconName":"facebook","iconColor":"#ffffff","iconColorHover":"","iconPosition":"left","iconGap":9,"openUrl":"","imageSrc":"","id":"none","tags":"remixcomponent facebook share socialShare shared_by_facebook","displayName":"Button","width":190,"widthStrategy":"fixed","height":44,"left":305,"leftStrategy":"dynamic","top":420,"szLeft":10,"szRight":10,"szTop":10,"szBottom":10,"displayType":"flow","data":{"nextScreenId":""}},"qufiwa":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'hereIsDetailedDescriptionResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"remixcomponent","displayName":"Text","width":268,"widthStrategy":"fixed","height":97,"left":266,"leftStrategy":"dynamic","top":250,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen result result2","disabled":false,"data":{"nextScreenId":""}}`,
                        },
                        {
                            name: getTranslation('resultWithPicture'),
                            icon: {
                                main: '/static/media/result_with_picture.svg',
                                hover: '/static/media/result_with_picture_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"","components":{"_orderedIds":["coo4xd","02ddlf","nnw8xd","iok7si","qm5aoy"],"coo4xd":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":333,"widthStrategy":"fixed","height":68,"left":233.5,"leftStrategy":"dynamic","top":294,"displayType":"flow","data":{"nextScreenId":""}},"02ddlf":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'tryAgain',
                            )}</strong></p>","sizeMod":"normal","borderRadius":2,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","id":"none","tags":"restart","displayName":"Button","width":195,"widthStrategy":"fixed","height":52,"left":195.5,"leftStrategy":"dynamic","top":472,"displayType":"flow","data":{"nextScreenId":""}},"nnw8xd":{"text":"U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;span class=U+34;ql-size-large ql-font-RobotoU+34; style=U+34;color: #FFFFFFU+34;U+62;ShareU+60;/spanU+62;U+60;/pU+62;","styleVariant":"none","sizeMod":"normal","borderRadius":40,"borderWidth":0,"borderColor":"","dropShadow":false,"backgroundColor":"#1877F2","isArrow":false,"arrowType":"default","arrowDirection":"right","arrowPosition":"center","arrowColor":"#fff","iconName":"facebook","iconColor":"#ffffff","iconColorHover":"","iconPosition":"left","iconGap":9,"openUrl":"","imageSrc":"","id":"none","tags":"remixcomponent facebook share socialShare shared_by_facebook","displayName":"Button","width":189,"widthStrategy":"fixed","height":47,"left":416,"leftStrategy":"dynamic","top":488,"szLeft":10,"szRight":10,"szTop":10,"szBottom":10,"displayType":"flow","data":{"nextScreenId":""}},"iok7si":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'hereIsDetailedDescriptionResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"remixcomponent","displayName":"Text","width":268,"widthStrategy":"fixed","height":72,"left":266,"leftStrategy":"dynamic","top":370,"displayType":"flow","data":{"nextScreenId":""}},"qm5aoy":{"width":375,"height":221,"backgroundSize":"cover","blur":false,"grayscale":false,"dropShadow":false,"borderWidth":1,"borderRadius":4,"borderColor":"#d8d8d8","animation":"none","src":"https://p.testix.me/images/products/common/i/Placeholder.png","srcThumb":"","id":"none","tags":"remixcomponent","displayName":"ProgressiveImage","widthStrategy":"fixed","left":212.5,"leftStrategy":"dynamic","top":59,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen result result2","disabled":false,"data":{"nextScreenId":""}}`,
                        },
                        {
                            name: getTranslation('backgroundImage'),
                            icon: {
                                main: '/static/media/background_image.svg',
                                hover: '/static/media/background_image_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/749114/3189","components":{"_orderedIds":["ik83z9","l603o2","xubjkp","4yix6b"],"ik83z9":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>YOUR RESULT</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":454,"widthStrategy":"fixed","height":70,"left":173,"leftStrategy":"dynamic","top":162,"displayType":"flow","data":{"nextScreenId":""}},"l603o2":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'tryAgain',
                            )}</strong></p>","sizeMod":"normal","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","id":"none","tags":"restart","displayName":"Button","width":195,"widthStrategy":"fixed","height":52,"left":302.5,"leftStrategy":"dynamic","top":391,"displayType":"flow","data":{"nextScreenId":""}},"xubjkp":{"text":"U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;span class=U+34;ql-size-large ql-font-RobotoU+34; style=U+34;color: #FFFFFFU+34;U+62;ShareU+60;/spanU+62;U+60;/pU+62;","styleVariant":"none","sizeMod":"normal","borderRadius":40,"borderWidth":0,"borderColor":"","dropShadow":false,"backgroundColor":"#1877F2","isArrow":false,"arrowType":"default","arrowDirection":"right","arrowPosition":"center","arrowColor":"#fff","iconName":"facebook","iconColor":"#ffffff","iconColorHover":"","iconPosition":"left","iconGap":9,"openUrl":"","imageSrc":"","id":"none","tags":"remixcomponent facebook share socialShare shared_by_facebook","displayName":"Button","width":190,"widthStrategy":"fixed","height":44,"left":305,"leftStrategy":"dynamic","top":420,"szLeft":10,"szRight":10,"szTop":10,"szBottom":10,"displayType":"flow","data":{"nextScreenId":""}},"4yix6b":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'hereIsDetailedDescriptionResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"remixcomponent","displayName":"Text","width":268,"widthStrategy":"fixed","height":97,"left":266,"leftStrategy":"dynamic","top":250,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen result result2","disabled":false,"data":{"nextScreenId":""}}`,
                        },
                    ],
                },
                {
                    show: true,
                    group: 'start_group',
                    name: getTranslation('cover'),
                    tag: 'start',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 0,
                },
                {
                    show: true,
                    group: 'user_form_group',
                    name: getTranslation('userForm'),
                    tag: 'user_form_screen_tag',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 4,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    /**
     * Photostory Configuration
     */
    PHOTOSTORY: {
        operations: {},
        controls: [
            ...getDefaultControls(),
            {
                // Добавление опции в контекстном меню
                what: WhatHelpers.componentsOnScreenWithTag('photostoryitem'),
                when: WhenHelpers.onlyOneSelectedAndHasTag('option'),
                place: 'quickcontrolpanel',
                view: 'addquickbutton', // в config.js этот контрол описан как тип 'quickcontrolpanel' и будет показываться только там
                name: 'AddHashlistElementControl',
                prototype: (control, { componentIds, componentProps }) => {
                    // if only one selected
                    if (!componentIds || componentIds.length !== 1) {
                        return null
                    }
                    const props = componentProps[componentIds[0]]
                    //TODO clone ?
                    return {
                        ...props,
                        text: 'Slide info',
                        left: props.left + 10,
                        top: props.top + 10,
                        data: { ...props.data, points: 0, popupId: '', copyPopupId: props.data.popupId }, // при добавлении новой опции она неверный ответ по умолчанию
                    }
                },
            },
            {
                what: 'app.collage.enable',
                when: 'always',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('collageOnFinalScreen'),
                sortIndex: 0,
            },
        ],
        screens: {
            showScreenControl: true,
            groups: [
                {
                    show: true,
                    group: 'photostory_group',
                    name: getTranslation('slides'),
                    tag: 'photostoryitem',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 2,
                    prototypes: [
                        {
                            name: getTranslation('horizontal'),
                            icon: {
                                main: '/static/media/horizontal_photostory_page_type.svg',
                                hover: '/static/media/horizontal_photostory_page_type_hover.svg',
                            },
                            json: `{
                            "backgroundColor": "#F7F7F7",
                            "backgroundImage": "",
                            "components": {
                              "_orderedIds": ["r5ty6g", "6khti4", "dw9ddo", "55fbl7"],
                              "r5ty6g": {
                                "width": 800,
                                "height": 400,
                                "backgroundSize": "cover",
                                "blur": false,
                                "grayscale": false,
                                "dropShadow": false,
                                "borderWidth": 0,
                                "borderRadius": 0,
                                "borderColor": "",
                                "animation": "none",
                                "src": "https://p.testix.me/images/products/common/i/Placeholder.png",
                                "srcThumb": "",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "ProgressiveImage",
                                "widthStrategy": "fixed",
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 0,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              },
                              "6khti4": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "left",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button prevTag",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "dw9ddo": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "right",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button nextTag",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 758,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "55fbl7": {
                                "text": "U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;strong class=U+34;ql-size-large ql-font-UbuntuU+34; style=U+34;color: rgb(136, 136, 136);U+34;U+62;YOUR DESCRIPTIONU+60;/strongU+62;U+60;/pU+62;",
                                "fontShadow": false,
                                "fontShadowColor": "rgba(0,0,0,0.2)",
                                "fontShadowDistance": 3,
                                "animationOnAppearance": "none",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "Text",
                                "width": 256,
                                "widthStrategy": "fixed",
                                "height": 63,
                                "left": 272,
                                "leftStrategy": "dynamic",
                                "top": 448.5,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              }
                            },
                            "tags": "screen photostoryitem",
                            "disabled": false,
                            "data": { "nextScreenId": "frvwdj" }
                          }`,
                        },
                        {
                            name: getTranslation('vertical'),
                            icon: {
                                main: '/static/media/vertical_photostory_page_type.svg',
                                hover: '/static/media/vertical_photostory_page_type_hover.svg',
                            },
                            json: `{
                            "backgroundColor": "#F7F7F7",
                            "backgroundImage": "",
                            "components": {
                              "_orderedIds": ["6kjyql", "v5ca8u", "nihr4a", "nwhind"],
                              "6kjyql": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "right",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button nextTag",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 758,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "v5ca8u": {
                                "width": 400,
                                "height": 600,
                                "backgroundSize": "cover",
                                "blur": false,
                                "grayscale": false,
                                "dropShadow": false,
                                "borderWidth": 0,
                                "borderRadius": 0,
                                "borderColor": "",
                                "animation": "none",
                                "src": "https://p.testix.me/images/products/common/i/Placeholder.png",
                                "srcThumb": "",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "ProgressiveImage",
                                "widthStrategy": "fixed",
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 0,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              },
                              "nihr4a": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "left",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button prevTag",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "nwhind": {
                                "text": "U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;strong class=U+34;ql-font-Ubuntu ql-size-largeU+34; style=U+34;color: rgb(136, 136, 136);U+34;U+62;YOUR DESCRIPTIONU+60;/strongU+62;U+60;/pU+62;",
                                "fontShadow": false,
                                "fontShadowColor": "rgba(0,0,0,0.2)",
                                "fontShadowDistance": 3,
                                "animationOnAppearance": "none",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "Text",
                                "width": 256,
                                "widthStrategy": "fixed",
                                "height": 63,
                                "left": 416,
                                "leftStrategy": "dynamic",
                                "top": 247.5,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              }
                            },
                            "tags": "screen photostoryitem",
                            "disabled": false,
                            "data": { "nextScreenId": "sd3ogt" }
                          }`,
                        },
                        {
                            name: getTranslation('centered'),
                            icon: {
                                main: '/static/media/centered_photostory_page_type.svg',
                                hover: '/static/media/centered_photostory_page_type_hover.svg',
                            },
                            json: `{
                            "backgroundColor": "#F7F7F7",
                            "backgroundImage": "",
                            "components": {
                              "_orderedIds": ["eetarg", "qzl4lb", "n9acau", "2psk4g"],
                              "eetarg": {
                                "width": 560,
                                "height": 270,
                                "backgroundSize": "cover",
                                "blur": false,
                                "grayscale": false,
                                "dropShadow": false,
                                "borderWidth": 0,
                                "borderRadius": 0,
                                "borderColor": "",
                                "animation": "none",
                                "src": "https://p.testix.me/images/products/common/i/Placeholder.png",
                                "srcThumb": "",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "ProgressiveImage",
                                "widthStrategy": "fixed",
                                "left": 119.5,
                                "leftStrategy": "dynamic",
                                "top": 139,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              },
                              "qzl4lb": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "left",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button prevTag",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "n9acau": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "right",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button nextTag",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 758,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "2psk4g": {
                                "text": "U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;strong class=U+34;ql-font-Ubuntu ql-size-largeU+34; style=U+34;color: rgb(136, 136, 136);U+34;U+62;YOUR DESCRIPTIONU+60;/strongU+62;U+60;/pU+62;",
                                "fontShadow": false,
                                "fontShadowColor": "rgba(0,0,0,0.2)",
                                "fontShadowDistance": 3,
                                "animationOnAppearance": "none",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "Text",
                                "width": 256,
                                "widthStrategy": "fixed",
                                "height": 63,
                                "left": 272,
                                "leftStrategy": "dynamic",
                                "top": 448.5,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              }
                            },
                            "tags": "screen photostoryitem",
                            "disabled": false,
                            "data": { "nextScreenId": "br3lcy" }
                          }`,
                        },
                    ],
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'final_group',
                    name: getTranslation('final'),
                    tag: 'final',
                    draggable: false,
                    canAdd: false,
                    canDelete: true,
                    canClone: false,
                    sortIndex: 5,
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'start_group',
                    name: getTranslation('cover'),
                    tag: 'start',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 0,
                },
                {
                    show: true,
                    group: 'user_form_group',
                    name: getTranslation('userForm'),
                    tag: 'user_form_screen_tag',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 4,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    /**
     * Quotes Configuration
     */
    QUOTES: {
        operations: {},
        controls: [
            ...getDefaultControls(),
            {
                // Добавление опции в контекстном меню
                what: WhatHelpers.componentsOnScreenWithTag('quotesitem'),
                when: WhenHelpers.onlyOneSelectedAndHasTag('option'),
                place: 'quickcontrolpanel',
                view: 'addquickbutton', // в config.js этот контрол описан как тип 'quickcontrolpanel' и будет показываться только там
                name: 'AddHashlistElementControl',
                prototype: (control, { componentIds, componentProps }) => {
                    // if only one selected
                    if (!componentIds || componentIds.length !== 1) {
                        return null
                    }
                    const props = componentProps[componentIds[0]]
                    //TODO clone ?
                    return {
                        ...props,
                        text: 'Slide info',
                        left: props.left + 10,
                        top: props.top + 10,
                        data: { ...props.data, points: 0, popupId: '', copyPopupId: props.data.popupId }, // при добавлении новой опции она неверный ответ по умолчанию
                    }
                },
            },
            {
                what: 'app.collage.enable',
                when: 'always',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('collageOnFinalScreen'),
                sortIndex: 0,
            },
        ],
        screens: {
            showScreenControl: true,
            groups: [
                {
                    show: true,
                    group: 'quotes_group',
                    name: getTranslation('slides'),
                    tag: 'quotesitem',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 2,
                    prototypes: [
                        {
                            name: getTranslation('horizontal'),
                            icon: {
                                main: '/static/media/horizontal_photostory_page_type.svg',
                                hover: '/static/media/horizontal_photostory_page_type_hover.svg',
                            },
                            json: `{
                            "backgroundColor": "#F7F7F7",
                            "backgroundImage": "",
                            "components": {
                              "_orderedIds": ["r5ty6g", "6khti4", "dw9ddo", "55fbl7"],
                              "r5ty6g": {
                                "width": 800,
                                "height": 400,
                                "backgroundSize": "cover",
                                "blur": false,
                                "grayscale": false,
                                "dropShadow": false,
                                "borderWidth": 0,
                                "borderRadius": 0,
                                "borderColor": "",
                                "animation": "none",
                                "src": "https://p.testix.me/images/products/common/i/Placeholder.png",
                                "srcThumb": "",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "ProgressiveImage",
                                "widthStrategy": "fixed",
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 0,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              },
                              "6khti4": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "left",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button prevTag quotes",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "dw9ddo": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "right",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button nextTag quotes",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 758,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "55fbl7": {
                                "text": "U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;strong class=U+34;ql-size-large ql-font-UbuntuU+34; style=U+34;color: rgb(136, 136, 136);U+34;U+62;YOUR DESCRIPTIONU+60;/strongU+62;U+60;/pU+62;",
                                "fontShadow": false,
                                "fontShadowColor": "rgba(0,0,0,0.2)",
                                "fontShadowDistance": 3,
                                "animationOnAppearance": "none",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "Text",
                                "width": 256,
                                "widthStrategy": "fixed",
                                "height": 63,
                                "left": 272,
                                "leftStrategy": "dynamic",
                                "top": 448.5,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              }
                            },
                            "tags": "screen quotesitem",
                            "disabled": false,
                            "data": { "nextScreenId": "frvwdj" }
                          }`,
                        },
                        {
                            name: getTranslation('vertical'),
                            icon: {
                                main: '/static/media/vertical_photostory_page_type.svg',
                                hover: '/static/media/vertical_photostory_page_type_hover.svg',
                            },
                            json: `{
                            "backgroundColor": "#F7F7F7",
                            "backgroundImage": "",
                            "components": {
                              "_orderedIds": ["6kjyql", "v5ca8u", "nihr4a", "nwhind"],
                              "6kjyql": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "right",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button nextTag quotes",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 758,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "v5ca8u": {
                                "width": 400,
                                "height": 600,
                                "backgroundSize": "cover",
                                "blur": false,
                                "grayscale": false,
                                "dropShadow": false,
                                "borderWidth": 0,
                                "borderRadius": 0,
                                "borderColor": "",
                                "animation": "none",
                                "src": "https://p.testix.me/images/products/common/i/Placeholder.png",
                                "srcThumb": "",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "ProgressiveImage",
                                "widthStrategy": "fixed",
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 0,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              },
                              "nihr4a": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "left",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button prevTag quotes",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "nwhind": {
                                "text": "U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;strong class=U+34;ql-font-Ubuntu ql-size-largeU+34; style=U+34;color: rgb(136, 136, 136);U+34;U+62;YOUR DESCRIPTIONU+60;/strongU+62;U+60;/pU+62;",
                                "fontShadow": false,
                                "fontShadowColor": "rgba(0,0,0,0.2)",
                                "fontShadowDistance": 3,
                                "animationOnAppearance": "none",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "Text",
                                "width": 256,
                                "widthStrategy": "fixed",
                                "height": 63,
                                "left": 416,
                                "leftStrategy": "dynamic",
                                "top": 247.5,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              }
                            },
                            "tags": "screen quotesitem",
                            "disabled": false,
                            "data": { "nextScreenId": "sd3ogt" }
                          }`,
                        },
                        {
                            name: getTranslation('centered'),
                            icon: {
                                main: '/static/media/centered_photostory_page_type.svg',
                                hover: '/static/media/centered_photostory_page_type_hover.svg',
                            },
                            json: `{
                            "backgroundColor": "#F7F7F7",
                            "backgroundImage": "",
                            "components": {
                              "_orderedIds": ["eetarg", "qzl4lb", "n9acau", "2psk4g"],
                              "eetarg": {
                                "width": 561,
                                "height": 270,
                                "backgroundSize": "cover",
                                "blur": false,
                                "grayscale": false,
                                "dropShadow": false,
                                "borderWidth": 0,
                                "borderRadius": 0,
                                "borderColor": "",
                                "animation": "none",
                                "src": "https://p.testix.me/images/products/common/i/Placeholder.png",
                                "srcThumb": "",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "ProgressiveImage",
                                "widthStrategy": "fixed",
                                "left": 119.5,
                                "leftStrategy": "dynamic",
                                "top": 139,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              },
                              "qzl4lb": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "left",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button prevTag quotes",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 0,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "n9acau": {
                                "text": "U+60;pU+62;U+60;brU+62;U+60;/pU+62;",
                                "sizeMod": "normal",
                                "borderRadius": 0,
                                "borderWidth": 0,
                                "borderColor": "",
                                "dropShadow": false,
                                "backgroundColor": "",
                                "isArrow": true,
                                "arrowType": "thin",
                                "arrowDirection": "right",
                                "arrowPosition": "center",
                                "arrowColor": "#fff",
                                "iconName": "",
                                "iconColor": "",
                                "iconPosition": "left",
                                "iconGap": 10,
                                "openUrl": "",
                                "id": "none",
                                "tags": "button nextTag quotes",
                                "displayName": "Button",
                                "width": 42,
                                "widthStrategy": "fixed",
                                "height": 64,
                                "left": 758,
                                "leftStrategy": "dynamic",
                                "top": 240,
                                "displayType": "decor",
                                "data": { "nextScreenId": "" }
                              },
                              "2psk4g": {
                                "text": "U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;strong class=U+34;ql-font-Ubuntu ql-size-largeU+34; style=U+34;color: rgb(136, 136, 136);U+34;U+62;YOUR DESCRIPTIONU+60;/strongU+62;U+60;/pU+62;",
                                "fontShadow": false,
                                "fontShadowColor": "rgba(0,0,0,0.2)",
                                "fontShadowDistance": 3,
                                "animationOnAppearance": "none",
                                "id": "none",
                                "tags": "remixcomponent",
                                "displayName": "Text",
                                "width": 256,
                                "widthStrategy": "fixed",
                                "height": 63,
                                "left": 272,
                                "leftStrategy": "dynamic",
                                "top": 448.5,
                                "displayType": "flow",
                                "data": { "nextScreenId": "" }
                              }
                            },
                            "tags": "screen quotesitem",
                            "disabled": false,
                            "data": { "nextScreenId": "br3lcy" }
                          }`,
                        },
                    ],
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'final_group',
                    name: getTranslation('final'),
                    tag: 'final',
                    draggable: false,
                    canAdd: false,
                    canDelete: true,
                    canClone: false,
                    sortIndex: 5,
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'start_group',
                    name: getTranslation('cover'),
                    tag: 'start',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 0,
                },
                {
                    show: true,
                    group: 'user_form_group',
                    name: getTranslation('userForm'),
                    tag: 'user_form_screen_tag',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 4,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    /**
     * Memory Configuration
     */
    MEMORY: {
        operations: {},
        controls: [
            ...getDefaultControls(),
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=MemoryPlayground].indent',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('cardsIndent'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=MemoryPlayground].cardRowOption',
                when: 'selected',
                place: 'rightpanel',
                view: 'dropdown',
                name: 'Alternative',
                label: getTranslation('playgroundRow'),
                possibleValues: [
                    { option: '4x2', value: '4x2' },
                    { option: '4x3', value: '4x3' },
                    { option: '4x4', value: '4x4' },
                    { option: '5x2', value: '5x2' },
                    { option: '5x4', value: '5x4' },
                    { option: '3x6', value: '3x6' },
                    { option: '6x4', value: '6x4' },
                    { option: '6x6', value: '6x6' },
                ],
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=MemoryPlayground].dataSet',
                when: 'selected',
                place: 'rightpanel',
                view: 'dataprovider',
                name: 'DataProvider',
                label: getTranslation('updateCards'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=MemoryPlayground].cardBackImgSrc',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('loadCardsBackImage'),
                sortIndex: 0,
            },
        ],
        screens: {
            showScreenControl: true,
            groups: [
                {
                    show: true,
                    group: 'memory_group',
                    name: getTranslation('workPlace'),
                    tag: 'memoryitem',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 2,
                    prototypes: [],
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'final_group',
                    name: getTranslation('final'),
                    tag: 'final',
                    draggable: false,
                    canAdd: false,
                    canDelete: true,
                    canClone: false,
                    sortIndex: 5,
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'start_group',
                    name: getTranslation('cover'),
                    tag: 'start',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 0,
                },
                {
                    show: true,
                    group: 'user_form_group',
                    name: getTranslation('userForm'),
                    tag: 'user_form_screen_tag',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 4,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    /**
     * Personality Configuration
     */
    PERSONALITY: {
        operations: {},
        controls: getDefaultControls(),
        screens: {
            showScreenControl: true,
            groups: [
                {
                    show: true,
                    group: 'question_group',
                    name: getTranslation('questions'),
                    tag: 'question',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 2,
                    prototypes: [
                        {
                            name: getTranslation('textQuestion'),
                            icon: {
                                main: '/static/media/text_question.svg',
                                hover: '/static/media/text_question_hover.svg',
                            },
                            json: `{"backgroundColor":"#F7F7F7","backgroundImage":"","components":{"_orderedIds":["emeh5f","fkrwjx","5pe80r","yrr89s","5pvg79"],"emeh5f":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-huge' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourQuestion',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":404,"widthStrategy":"fixed","height":55,"left":198,"leftStrategy":"dynamic","top":156,"displayType":"flow","data":{"nextScreenId":""}},"fkrwjx":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 1</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"none","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":300,"displayType":"flow","data":{"nextScreenId":"","points":0}},"5pe80r":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 2</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":300,"displayType":"flow","data":{"nextScreenId":"","points":0}},"yrr89s":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 3</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":403,"displayType":"flow","data":{"nextScreenId":"","points":0}},"5pvg79":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 4</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"yrr89s","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":403,"displayType":"flow","data":{"nextScreenId":"","points":0}}},"tags":"screen question question1","disabled":false,"data":{"nextScreenId":"1ekp37"},"staticMarkup":"","hashlistId":"z6z9sh"}`,
                        },
                        {
                            name: getTranslation('photoSlide'),
                            icon: {
                                main: '/static/media/photo_question.svg',
                                hover: '/static/media/photo_question_hover.svg',
                            },
                            json: `{"backgroundColor":"#F7F7F7","backgroundImage":"","components":{"_orderedIds":["6gn666","pho6dj","otvi7n","m009g4","z7hxdh","rw77bd"],"6gn666":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-huge' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourQuestion',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":404,"widthStrategy":"fixed","height":55,"left":198,"leftStrategy":"dynamic","top":50,"displayType":"flow","data":{"nextScreenId":""}},"pho6dj":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 1</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"none","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":363,"displayType":"flow","data":{"nextScreenId":"","points":0}},"otvi7n":{"text":"<p class='ql-align-center'><strong class='ql-size-large ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 2</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":363,"displayType":"flow","data":{"nextScreenId":"","points":0}},"m009g4":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 3</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"fkrwjx","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":129.5,"leftStrategy":"dynamic","top":467,"displayType":"flow","data":{"nextScreenId":"","points":0}},"z7hxdh":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'option',
                            )} 4</strong></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"","id":"yrr89s","tags":"question option","displayName":"TextOption","width":258,"widthStrategy":"fixed","height":81,"left":411.5,"leftStrategy":"dynamic","top":467,"displayType":"flow","data":{"nextScreenId":"","points":0}},"rw77bd":{"width":400,"height":207,"backgroundSize":"cover","blur":false,"grayscale":false,"dropShadow":false,"borderWidth":0,"borderRadius":4,"borderColor":"#000000","animation":"none","src":"https://p.testix.me/images/products/common/i/Placeholder.png","srcThumb":"","id":"none","tags":"remixcomponent","displayName":"ProgressiveImage","widthStrategy":"fixed","left":200,"leftStrategy":"dynamic","top":126,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen question question1","disabled":false,"data":{"nextScreenId":"908325"},"staticMarkup":"","hashlistId":"1ekp37"}`,
                        },
                        {
                            name: getTranslation('photoOptions'),
                            icon: {
                                main: '/static/media/photo_answer.svg',
                                hover: '/static/media/photo_answer_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"","components":{"_orderedIds":["rnlv4a","9dqhi2","z4dqtm","hxfwp3"],"rnlv4a":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourQuestion',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":404,"widthStrategy":"fixed","height":55,"left":198,"leftStrategy":"dynamic","top":88,"displayType":"flow","data":{"nextScreenId":""}},"9dqhi2":{"text":"<p class='ql-align-center'><br></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":0,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/1207675/2684","id":"none","tags":"question option","displayName":"TextOption","width":197,"widthStrategy":"fixed","height":200,"left":74,"leftStrategy":"dynamic","top":212,"displayType":"flow","data":{"nextScreenId":"","points":0}},"z4dqtm":{"text":"<p><br></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":0,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/1207675/2684","id":"9dqhi2","tags":"question option","displayName":"TextOption","width":197,"widthStrategy":"fixed","height":200,"left":301.5,"leftStrategy":"dynamic","top":212,"displayType":"flow","data":{"nextScreenId":"","points":0}},"hxfwp3":{"text":"<p><br></p>","correctIndicator":"none","percent":0,"textAlign":"left","borderRadius":4,"borderWidth":3,"borderColor":"#D8D8D8","dropShadow":false,"backgroundColor":"#FFFFFF","imageSrc":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/1207675/2684","id":"z4dqtm","tags":"question option","displayName":"TextOption","width":197,"widthStrategy":"fixed","height":200,"left":530,"leftStrategy":"dynamic","top":212,"displayType":"flow","data":{"nextScreenId":"","points":0}}},"tags":"screen question question1","disabled":false,"data":{"nextScreenId":"idByFunction:calcTriviaRes"},"staticMarkup":"","hashlistId":"908325"}`,
                        },
                    ],
                    minLength: 1,
                },
                {
                    show: true,
                    group: 'result_group',
                    name: getTranslation('results'),
                    tag: 'result',
                    draggable: true,
                    canAdd: true,
                    canDelete: true,
                    canClone: true,
                    sortIndex: 5,
                    minLength: 1,
                    prototypes: [
                        {
                            name: getTranslation('plainText'),
                            icon: {
                                main: '/static/media/plain_text.svg',
                                hover: '/static/media/plain_text_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"","components":{"_orderedIds":["a5zqu2","87djai","5btnep","qufiwa"],"a5zqu2":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":454,"widthStrategy":"fixed","height":70,"left":173,"leftStrategy":"dynamic","top":162,"displayType":"flow","data":{"nextScreenId":""}},"87djai":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'tryAgain',
                            )}</strong></p>","sizeMod":"normal","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","id":"none","tags":"restart","displayName":"Button","width":195,"widthStrategy":"fixed","height":52,"left":302.5,"leftStrategy":"dynamic","top":391,"displayType":"flow","data":{"nextScreenId":""}},"5btnep":{"text":"U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;span class=U+34;ql-size-large ql-font-RobotoU+34; style=U+34;color: #FFFFFFU+34;U+62;ShareU+60;/spanU+62;U+60;/pU+62;","styleVariant":"none","sizeMod":"normal","borderRadius":40,"borderWidth":0,"borderColor":"","dropShadow":false,"backgroundColor":"#1877F2","isArrow":false,"arrowType":"default","arrowDirection":"right","arrowPosition":"center","arrowColor":"#fff","iconName":"facebook","iconColor":"#ffffff","iconColorHover":"","iconPosition":"left","iconGap":9,"openUrl":"","imageSrc":"","id":"none","tags":"remixcomponent facebook share socialShare shared_by_facebook","displayName":"Button","width":190,"widthStrategy":"fixed","height":44,"left":305,"leftStrategy":"dynamic","top":420,"szLeft":10,"szRight":10,"szTop":10,"szBottom":10,"displayType":"flow","data":{"nextScreenId":""}},"qufiwa":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'hereIsDetailedDescriptionResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"remixcomponent","displayName":"Text","width":268,"widthStrategy":"fixed","height":97,"left":266,"leftStrategy":"dynamic","top":250,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen result result2","disabled":false,"data":{"nextScreenId":""}}`,
                        },
                        {
                            name: getTranslation('resultWithPicture'),
                            icon: {
                                main: '/static/media/result_with_picture.svg',
                                hover: '/static/media/result_with_picture_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"","components":{"_orderedIds":["coo4xd","02ddlf","nnw8xd","iok7si","qm5aoy"],"coo4xd":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'yourResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":333,"widthStrategy":"fixed","height":68,"left":233.5,"leftStrategy":"dynamic","top":294,"displayType":"flow","data":{"nextScreenId":""}},"02ddlf":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'tryAgain',
                            )}</strong></p>","sizeMod":"normal","borderRadius":2,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","id":"none","tags":"restart","displayName":"Button","width":195,"widthStrategy":"fixed","height":52,"left":195.5,"leftStrategy":"dynamic","top":472,"displayType":"flow","data":{"nextScreenId":""}},"nnw8xd":{"text":"U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;span class=U+34;ql-size-large ql-font-RobotoU+34; style=U+34;color: #FFFFFFU+34;U+62;ShareU+60;/spanU+62;U+60;/pU+62;","styleVariant":"none","sizeMod":"normal","borderRadius":40,"borderWidth":0,"borderColor":"","dropShadow":false,"backgroundColor":"#1877F2","isArrow":false,"arrowType":"default","arrowDirection":"right","arrowPosition":"center","arrowColor":"#fff","iconName":"facebook","iconColor":"#ffffff","iconColorHover":"","iconPosition":"left","iconGap":9,"openUrl":"","imageSrc":"","id":"none","tags":"remixcomponent facebook share socialShare shared_by_facebook","displayName":"Button","width":189,"widthStrategy":"fixed","height":47,"left":416,"leftStrategy":"dynamic","top":488,"szLeft":10,"szRight":10,"szTop":10,"szBottom":10,"displayType":"flow","data":{"nextScreenId":""}},"iok7si":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'hereIsDetailedDescriptionResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"remixcomponent","displayName":"Text","width":268,"widthStrategy":"fixed","height":72,"left":266,"leftStrategy":"dynamic","top":370,"displayType":"flow","data":{"nextScreenId":""}},"qm5aoy":{"width":375,"height":221,"backgroundSize":"cover","blur":false,"grayscale":false,"dropShadow":false,"borderWidth":1,"borderRadius":4,"borderColor":"#d8d8d8","animation":"none","src":"https://p.testix.me/images/products/common/i/Placeholder.png","srcThumb":"","id":"none","tags":"remixcomponent","displayName":"ProgressiveImage","widthStrategy":"fixed","left":212.5,"leftStrategy":"dynamic","top":59,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen result result2","disabled":false,"data":{"nextScreenId":""}}`,
                        },
                        {
                            name: getTranslation('backgroundImage'),
                            icon: {
                                main: '/static/media/background_image.svg',
                                hover: '/static/media/background_image_hover.svg',
                            },
                            json: `{"backgroundColor":"#EEEEEE","backgroundImage":"https://backend-dev-bucket.s3.eu-central-1.amazonaws.com/697676/media/749114/3189","components":{"_orderedIds":["ik83z9","l603o2","xubjkp","4yix6b"],"ik83z9":{"text":"<p class='ql-align-center'><strong class='ql-size-huge ql-font-Ubuntu' style='color: rgb(136, 136, 136);'>YOUR RESULT</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"question title","displayName":"Text","width":454,"widthStrategy":"fixed","height":70,"left":173,"leftStrategy":"dynamic","top":162,"displayType":"flow","data":{"nextScreenId":""}},"l603o2":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'tryAgain',
                            )}</strong></p>","sizeMod":"normal","borderRadius":4,"borderWidth":1,"borderColor":"#d8d8d8","dropShadow":false,"backgroundColor":"#FFFFFF","id":"none","tags":"restart","displayName":"Button","width":195,"widthStrategy":"fixed","height":52,"left":302.5,"leftStrategy":"dynamic","top":391,"displayType":"flow","data":{"nextScreenId":""}},"xubjkp":{"text":"U+60;p class=U+34;ql-align-centerU+34;U+62;U+60;span class=U+34;ql-size-large ql-font-RobotoU+34; style=U+34;color: #FFFFFFU+34;U+62;ShareU+60;/spanU+62;U+60;/pU+62;","styleVariant":"none","sizeMod":"normal","borderRadius":40,"borderWidth":0,"borderColor":"","dropShadow":false,"backgroundColor":"#1877F2","isArrow":false,"arrowType":"default","arrowDirection":"right","arrowPosition":"center","arrowColor":"#fff","iconName":"facebook","iconColor":"#ffffff","iconColorHover":"","iconPosition":"left","iconGap":9,"openUrl":"","imageSrc":"","id":"none","tags":"remixcomponent facebook share socialShare shared_by_facebook","displayName":"Button","width":190,"widthStrategy":"fixed","height":44,"left":305,"leftStrategy":"dynamic","top":420,"szLeft":10,"szRight":10,"szTop":10,"szBottom":10,"displayType":"flow","data":{"nextScreenId":""}},"4yix6b":{"text":"<p class='ql-align-center'><strong class='ql-font-Ubuntu ql-size-large' style='color: rgb(136, 136, 136);'>${getTranslation(
                                'hereIsDetailedDescriptionResult',
                            )}</strong></p>","fontShadow":false,"fontShadowColor":"rgba(0,0,0,0.2)","fontShadowDistance":3,"animationOnAppearance":"none","id":"none","tags":"remixcomponent","displayName":"Text","width":268,"widthStrategy":"fixed","height":97,"left":266,"leftStrategy":"dynamic","top":250,"displayType":"flow","data":{"nextScreenId":""}}},"tags":"screen result result2","disabled":false,"data":{"nextScreenId":""}}`,
                        },
                    ],
                },
                {
                    show: true,
                    group: 'start_group',
                    name: getTranslation('cover'),
                    tag: 'start',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 0,
                },
                {
                    show: true,
                    group: 'user_form_group',
                    name: getTranslation('userForm'),
                    tag: 'user_form_screen_tag',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 4,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    /**
     * Rank Battle Configuration
     */
    RANK_BATTLE: {
        operations: {
            // описывают какие действия можно делать в редакторе
            //TODO
            // drag and drop components into the screen - descibe these kind of operations
            // add new screens - screen prototypes.
            // what kind of options user may add on the screen? only textoption, only imageoption, other?
            // copy-paste operations ?
            // adding new options by prototype
        },
        controls: [
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=RankBattlePlayground].imageLinks',
                when: 'selected',
                place: 'rightpanel',
                view: 'dataprovider',
                name: 'DataProvider',
                label: getTranslation('rankCards'),
                sortIndex: 0,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.backgroundColor',
                when: 'screenShown',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('backgroundColor'),
                sortIndex: 40,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.backgroundImage',
                when: 'screenShown',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('backgroundImage'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].src',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('chooseImage'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderRadius',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderRadius'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderWidth',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderWidth'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('borderColor'),
                sortIndex: 40,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].dropShadow',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('dropShadow'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].blur',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('blur'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].grayscale',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('grayscale'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderRadius',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderRadius'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderWidth',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderWidth'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('borderColor'),
                sortIndex: 40,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].backgroundColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('backgroundColor'),
                sortIndex: 40,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].dropShadow',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('dropShadow'),
                sortIndex: 0,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].openUrl',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('openUrl'),
                sortIndex: 0,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].imageSrc',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('icon'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=RankBattlePlayground].highlightColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('highlightColorOfLeader'),
                sortIndex: 40,
            },
            {
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.onlyOneSelectedAndDisplayNameNotEqual('RankBattlePlayground'),
                place: 'quickcontrolpanel',
                view: 'deletequickbutton',
                name: 'DeleteHashlistElementControl',
                sortIndex: -1,
            },
            {
                // Перестановка компонента на задний план
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.onlyOneSelected(),
                place: 'quickcontrolpanel',
                view: 'textlabel',
                name: 'TextLabel',
                props: {
                    text: getTranslation('sendToBack'),
                    icon: '/static/media/move-down.svg',
                    onClick: control => {
                        control.controlEventCallback(
                            window.ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED,
                            control,
                            {
                                newElementIndex: 0,
                            },
                        )
                    },
                },
            },
            {
                // Перестановка компонента на передний план
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.onlyOneSelected(),
                place: 'quickcontrolpanel',
                view: 'textlabel',
                name: 'TextLabel',
                props: {
                    text: getTranslation('bringToFront'),
                    icon: '/static/media/move-up.svg',
                    onClick: control => {
                        control.controlEventCallback(
                            window.ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED,
                            control,
                            {
                                newElementIndex: 9999,
                            },
                        )
                    },
                },
            },
            {
                // Общее выравнивание группы элементов "Tidy up"
                // Если по top/left/w/h у группы компонентов небольшое отличие то эти значения усредняются и элементы выравниваются
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.groupSelected(),
                place: 'quickcontrolpanel',
                view: 'textlabel',
                name: 'TextLabel',
                props: {
                    text: getTranslation('tidyUp'),
                    icon: '/static/media/tidy-up.svg',
                    onClick: control => {
                        control.controlEventCallback(window.ControlManager.EVENT_PROCESS_SELECTED_COMPONENTS, control, {
                            process: ControlHelpers.tidyUp,
                        })
                    },
                },
            },
            //TODO четыре контрола инпута Safe zone в будущем надо объединить в один специальный контрол чтобы выглядело компактнее
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szTop',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szTop'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szLeft',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szLeft'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szRight',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szRight'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szBottom',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szBottom'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components./^[0-9a-z]+$/.displayType',
                when: 'selected',
                place: 'rightpanel',
                view: 'dropdown',
                name: 'Alternative',
                label: getTranslation('displayType'),
                possibleValues: [
                    { option: getTranslation('flow'), value: 'flow' },
                    { option: getTranslation('decor'), value: 'decor' },
                ],
                sortIndex: 0,
                isExpert: true,
            },
        ],
        screens: {
            showScreenControl: false,
            groups: [
                {
                    show: true,
                    group: 'question_group',
                    name: getTranslation('questions'),
                    tag: 'screen',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 2,
                    prototypes: [],
                    minLength: 1,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    /**
     * Before After
     */
    BEFORE_AFTER: {
        operations: {
            // описывают какие действия можно делать в редакторе
            //TODO
            // drag and drop components into the screen - descibe these kind of operations
            // add new screens - screen prototypes.
            // what kind of options user may add on the screen? only textoption, only imageoption, other?
            // copy-paste operations ?
            // adding new options by prototype
        },
        controls: [
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=BeforeAfter].leftImage',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('leftImage'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=BeforeAfter].rightImage',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('rightImage'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=BeforeAfter].dividerColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('dividerColor'),
                sortIndex: 40,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.backgroundColor',
                when: 'screenShown',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('backgroundColor'),
                sortIndex: 40,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.backgroundImage',
                when: 'screenShown',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('backgroundImage'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].src',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('chooseImage'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderRadius',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderRadius'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderWidth',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderWidth'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].borderColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('borderColor'),
                sortIndex: 40,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].dropShadow',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('dropShadow'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].blur',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('blur'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=ProgressiveImage].grayscale',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('grayscale'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderRadius',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderRadius'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderWidth',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('borderWidth'),
                sortIndex: 0,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].borderColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('borderColor'),
                sortIndex: 40,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].backgroundColor',
                when: 'selected',
                place: 'rightpanel',
                view: 'colorpicker',
                name: 'StringControl',
                label: getTranslation('backgroundColor'),
                sortIndex: 40,
            },
            {
                what:
                    'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].dropShadow',
                when: 'selected',
                place: 'rightpanel',
                view: 'onoffswitcher',
                name: 'OnOff',
                label: getTranslation('dropShadow'),
                sortIndex: 0,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].openUrl',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('openUrl'),
                sortIndex: 0,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/ displayName=Button].imageSrc',
                when: 'selected',
                place: 'rightpanel',
                view: 'chooseimage',
                name: 'ChooseImage',
                label: getTranslation('icon'),
                sortIndex: 0,
            },
            {
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.onlyOneSelectedAndDisplayNameNotEqual('BeforeAfter'),
                place: 'quickcontrolpanel',
                view: 'deletequickbutton',
                name: 'DeleteHashlistElementControl',
                sortIndex: -1,
            },
            {
                // Перестановка компонента на задний план
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.onlyOneSelected(),
                place: 'quickcontrolpanel',
                view: 'textlabel',
                name: 'TextLabel',
                props: {
                    text: getTranslation('sendToBack'),
                    icon: '/static/media/move-down.svg',
                    onClick: control => {
                        control.controlEventCallback(
                            window.ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED,
                            control,
                            {
                                newElementIndex: 0,
                            },
                        )
                    },
                },
            },
            {
                // Перестановка компонента на передний план
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.onlyOneSelected(),
                place: 'quickcontrolpanel',
                view: 'textlabel',
                name: 'TextLabel',
                props: {
                    text: getTranslation('bringToFront'),
                    icon: '/static/media/move-up.svg',
                    onClick: control => {
                        control.controlEventCallback(
                            window.ControlManager.EVENT_HASHLIST_CHANGE_POSITION_REQUESTED,
                            control,
                            {
                                newElementIndex: 9999,
                            },
                        )
                    },
                },
            },
            {
                // Общее выравнивание группы элементов "Tidy up"
                // Если по top/left/w/h у группы компонентов небольшое отличие то эти значения усредняются и элементы выравниваются
                what: WhatHelpers.anyComponentOnScreen(),
                when: WhenHelpers.groupSelected(),
                place: 'quickcontrolpanel',
                view: 'textlabel',
                name: 'TextLabel',
                props: {
                    text: getTranslation('tidyUp'),
                    icon: '/static/media/tidy-up.svg',
                    onClick: control => {
                        control.controlEventCallback(window.ControlManager.EVENT_PROCESS_SELECTED_COMPONENTS, control, {
                            process: ControlHelpers.tidyUp,
                        })
                    },
                },
            },
            //TODO четыре контрола инпута Safe zone в будущем надо объединить в один специальный контрол чтобы выглядело компактнее
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szTop',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szTop'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szLeft',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szLeft'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szRight',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szRight'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components.[/^[0-9a-z]+$/].szBottom',
                when: 'selected',
                place: 'rightpanel',
                view: 'textinput',
                name: 'StringControl',
                label: getTranslation('szBottom'),
                sortIndex: 0,
                isExpert: true,
            },
            {
                what: 'router.[screens HashList]./^[0-9a-z]+$/.components./^[0-9a-z]+$/.displayType',
                when: 'selected',
                place: 'rightpanel',
                view: 'dropdown',
                name: 'Alternative',
                label: getTranslation('displayType'),
                possibleValues: [
                    { option: getTranslation('flow'), value: 'flow' },
                    { option: getTranslation('decor'), value: 'decor' },
                ],
                sortIndex: 0,
                isExpert: true,
            },
        ],
        screens: {
            showScreenControl: false,
            groups: [
                {
                    show: true,
                    group: 'question_group',
                    name: getTranslation('questions'),
                    tag: 'screen',
                    draggable: false,
                    canAdd: false,
                    canDelete: false,
                    canClone: false,
                    sortIndex: 2,
                    prototypes: [],
                    minLength: 1,
                },
            ],
        },
        components: getDefaultComponents(),
    },
    BLOCK_ARTICLE: {
        isBlockEditor: true,
        hideDeviceSwitcher: true,
        topbarmode: 'fixed',
        height: 'auto',
        operations: {},
        controls: [],
        screens: {},
        components: getDefaultComponents(),
    },
}

window.config.products = { projectType }

export default projectType
